import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { XMLElementBaseComponent } from './base';
import { ChildRendererService } from './child-renderer.service';
import { XMLComponentResolverService } from './resolver.service';

@Component({
  selector: 'app-vw-dynamic',
  imports: [CommonModule],
  template: `
    <div #dynamicContent></div>
    <!-- <div class="bg-slate-50 text-xs">{{ element | json }}</div> -->
  `,
})
export class DynamicXMLElementComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() element: any;
  @Input() dbId: string | undefined;
  @Input() provider!: string;

  private resolver = inject(XMLComponentResolverService);
  private childRenderService = inject(ChildRendererService);

  showFallback = false;
  @ViewChild('dynamicContent', { read: ViewContainerRef }) dynamicContainer!: ViewContainerRef;
  private componentRef: ComponentRef<XMLElementBaseComponent> | null = null;

  ngOnInit() {
    this.childRenderService.setDbId(this.dbId || '');
  }

  ngAfterViewInit() {
    this.renderComponent();
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  shouldRenderChild(child: any): boolean {
    // Don't render these child types - let parent components handle them
    const parentHandledChildren = ['im-bild'];
    return !parentHandledChildren.includes(child.tag);
  }

  private renderComponent() {
    const componentType = this.resolver.getComponent(this.element?.tag);

    if (componentType) {
      try {
        this.componentRef = this.dynamicContainer.createComponent(componentType);
        this.componentRef.instance.data = this.element;
        this.componentRef.instance.dbId = this.dbId;
        this.componentRef.instance.provider = this.provider;
        this.showFallback = false;
      } catch (error) {
        console.error('Failed to create component:', this.element?.tag, error);
        this.showFallback = true;
      }
    } else {
      this.showFallback = true;
    }
  }
}
